export default __webpack_public_path__ + "static/media/logo-white.18e96518.svg";